module.exports = __webpack_public_path__ + "static/img/24.79a14740.png";